import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chart"]

  update() {
    const self = this

    this.chartTargets.forEach(function(chart) {
      if (chart.dataset.type === self.type) {
        chart.hidden = false
      } else {
        chart.hidden = true
      }
    })
  }

  get type() {
    return this.element.elements["type"].value
  }
}
